import { IMenuType, IMobileMenu } from "../types/menu-d-t";

const menuData:IMenuType[] = [
  {
    link: '/',
    title: 'Home',
    hasDropdown: false,
    megamenu: false,
  },
  {
    link: '/shop',
    title: 'Shop',
    hasDropdown: true,
    megamenu: false,
    dropdownItems: [
      { link: '/shop/wishlist', title: 'Wishlist' },
      { link: '/shop/compare', title: 'Compare' },
    ]
  },
  {
    link: '/contact',
    title: 'Contact',
  },
]

export default menuData;

// mobile menus
export const mobile_menus:IMobileMenu[] = [
  {

    title: 'Home',
    link: '/',
  },
  {
    title: "Shop",
    link: '/shop',
  },
  {
    title: "Other Pages",
    dropdownMenu: [
      { link: '/shop/wishlist', title: 'Wishlist' },
      { link: '/shop/compare', title: 'Compare' },
    ],
  },
  {
    title: "Contact",
    link: '/contact',
  },
];
